module.exports = "<TextField\n  label=\"Persistent help text\"\n  helperText=\"This is the helperText\"\n  helperTextPersistent\n/>\n"